<template>
  <div>
    <div class="header">猜你喜欢</div>
    <div v-if="goodsList">
      <div v-for="(goods, idx) in goodsList.goods" :key="idx" class="goods-item" @click="handleDetail(goods)">
        <img class="image" :src="goods.goods_img"/>
        <div class="cnt">
          <div>
            <div class="title">
                        <span
                            class="platform">{{ goods.provider_name }}</span>{{ goods.title }}
            </div>

<!--            <div class="commission">-->
<!--              <div>神券100元</div>-->
<!--              <div>7.5折</div>-->
<!--            </div>-->
          </div>
          <div class="price">券后价<span style="font-size: 16px;">￥{{ goods.cost_price }}</span></div>
        </div>
        <div class="tag">
          <div>营销</div>
          <div>{{ goods.public_commission_rate }}%</div>
        </div>
      </div>
    </div>
    <div v-else class="swiper" style="display: flex;align-items: center;justify-content: center;">
      <a-spin/>
    </div>

  </div>
</template>

<script>
import {fetchGoodsLike} from '@/api/goods-list'

export default {
  name: "recommand-goods",
  props: {
    gid: String,
    pvd: String,
  },
  mounted() {
    this.fetchGoods()
  },
  data() {
    return {
      goodsList: undefined
    }
  },
  methods: {
    fetchGoods() {
      fetchGoodsLike({
        p: '1',
        size: '20',
        gid: this.gid,
        type: this.pvd
      }).then(res => {
        console.log(res)
        this.goodsList = res
      })
    },
    handleDetail(goods) {
      console.log(goods)
      this.$router.push({
        path: '/goods-detail',
        query: {
          id: goods.good_id,
          pvd: goods.provider,
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.goods-item {
  display: flex;
  height: 104px;
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #F3F3F3;
  margin: 6px 0px;
  padding: 6px;
  overflow: hidden;
  position: relative;
  cursor: pointer;

  .image {
    height: 92px;
    width: 92px;
    margin-right: 10px;
    flex-shrink: 0;
    border-radius: 10px;
  }

  .cnt {
    flex-grow: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
      line-height: 22px;

      .platform {
        font-size: 10px;
        height: 14px;
        line-height: 14px;
        padding-left: 4px;
        padding-right: 4px;
        background: #ff4242;
        border-radius: 20px;
        color: white;
        margin-right: 4px;
      }

    }

    .commission {
      display: flex;
      font-size: 10px;
    }

    .price {
      font-size: 11px;
      font-weight: 500;
      color: #FF4242;
      line-height: 16px;
    }

  }

  .tag {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 52px;
    height: 36px;
    border-radius: 12px 0px 12px 0px;
    font-size: 15px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: linear-gradient(225deg, #F85041 0%, #F8703C 100%);
  }

}

</style>
